import { createSelector } from '@reduxjs/toolkit';
import { TRootState } from 'store';

export const getAccessToken = (state: TRootState) => state.auth.accessToken;
export const getRefreshToken = (state: TRootState) => state.auth.refreshToken;
export const getUserId = (state: TRootState) => state.auth.userId;
export const getUserTier = (state: TRootState) => state.auth.userTier;
export const getUserTotalConversationCount = (state: TRootState) =>
  state.auth.userTotalConversationCount;
export const isInitialAuthDone = (state: TRootState) => state.auth.isInitialAuthDone;
export const isNotAuthorizedTier = (state: TRootState) => state.auth.isNotAuthorizedTier;
export const getIsFirebaseAuthenticated = (state: TRootState) => state.auth.isFirebaseAuthenticated;

export const isAuthenticated = createSelector(
  getIsFirebaseAuthenticated,
  getAccessToken,
  getRefreshToken,
  (isFirebaseAuth, accessToken, refreshToken) => {
    if (isFirebaseAuth) {
      return true;
    }
    // Fall back to legacy token-based authentication
    return !!accessToken && !!refreshToken;
  }
);

export const getCurrentRoute = (state: TRootState) => state.auth.currentRoute;

export const shouldSeeAllLessons = createSelector(getUserTier, tier =>
  ['subscriber', 'free_trial_user'].includes(tier ?? '')
);
